import styled from '@emotion/styled';

import theme from 'theme';
import {SizeTokenValue} from 'common';
import {CheckIcon, ErrorIcon, InfoIcon, WarningOutlineIcon} from 'icons';

import {BannerVariant} from '../types';

import type {BannerProps} from '../types';
import type {ReactNode} from 'react';

const typeIcon = (variant: BannerVariant, size: SizeTokenValue): ReactNode => {
  const resultSize =
    size === SizeTokenValue.XSmall || size === SizeTokenValue.XXSmall ? SizeTokenValue.Small : SizeTokenValue.Medium;

  switch (variant) {
    case BannerVariant.DefaultBlue:
      return <InfoIcon size={resultSize} color={theme.colors.additional.blue[80]} />;
    case BannerVariant.DefaultGrey:
      return <InfoIcon size={resultSize} color={theme.colors.grey[60]} />;
    case BannerVariant.Success:
      return <CheckIcon size={resultSize} color={theme.colors.additional.green[80]} />;
    case BannerVariant.Warning:
      return <WarningOutlineIcon size={resultSize} color={theme.colors.additional.yellow[80]} />;
    case BannerVariant.Error:
      return <ErrorIcon size={resultSize} color={theme.colors.additional.red[80]} />;
  }
};

const Container = styled.div`
  svg {
    vertical-align: top;
  }
`;

type IconProps = Pick<BannerProps, 'icon'> & Required<Pick<BannerProps, 'variant' | 'size'>>;

export const Icon: React.FC<IconProps> = ({icon, size, variant}) => {
  if (icon === false) {
    return null;
  }

  const child = icon && icon !== true ? icon : typeIcon(variant, size);

  return <Container>{child}</Container>;
};
